import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { rem } from 'polished'
import { FlightsCreditDetails } from 'components/Flights/types'
import { isFlightsCredit } from 'selectors/flightsSelectors'

import CreditRebookingModal from 'components/Flights/CreditRebooking/CreditRebookingModal'
import LayoutContainer from 'components/Common/LayoutContainer'
import RebookingConditions from 'components/Flights/CreditRebooking//RebookingConditions'

const ContentContainer = styled(LayoutContainer)`
  padding: ${rem(48)} ${rem(16)};
`

interface Props {
  isFlightsCredit: boolean;
  creditDetails: FlightsCreditDetails;
}

function FlightsCreditView(props: Props) {
  const { isFlightsCredit, creditDetails } = props
  const showTermsAndConditions = isFlightsCredit && creditDetails
  const showCreditRebookingModal = isFlightsCredit && !creditDetails

  return <>
    <CreditRebookingModal isOpen={showCreditRebookingModal}/>
    {showTermsAndConditions && <ContentContainer size="md">
      <RebookingConditions creditDetails={creditDetails} />
    </ContentContainer>}
  </>
}

function mapStateToProps(state: App.State) {
  return {
    creditDetails: state.flights.creditDetails,
    isFlightsCredit: isFlightsCredit(state),
  }
}

export default connect(mapStateToProps)(FlightsCreditView)
